<template>
<div class="container-fluid" >

 <div class="card border-success">

  <div class="card-header text-white bg-primary">
    <h4><i class="fas fa-briefcase mr-2" aria-hidden="true"></i>VALORIZZAZIONE STOCK SEDE</h4>
  </div> 

  <div  class="card-body"> 
 
  <div class="row">
  <div v-if="type=='A'" class="col-md-4">
    <div> 

    <div class="" >
    <div class="">
      <i style="color:blue" class="fas fa-stream mr-2" aria-hidden="true"></i>
      <strong>PARAMETRI DI RICERCA</strong>
      <hr>
    </div>
      <div class="card-body text-dark">


      <form name="movementSearch" v-on:submit.prevent="submit()">
      <store-select v-bind:props="store"  @update="setStoreId"></store-select>    
      <year-select  v-bind:props="season_year" @update="setYear"></year-select>
      <season-select v-bind:props="season"  @update="setSeasonId"></season-select>
      <department-select v-bind:props="department" @update="setDepartmentId"></department-select>

      <div class="form-check">
      <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="1" checked v-model="option">
      <label class="form-check-label" for="exampleRadios1">
        Valorizza a prezzo e sconto acquisto.
      </label>
    </div>
    <div class="form-check">
    <input class="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="2" v-model="option">
    <label class="form-check-label" for="exampleRadios2">
      Valorizza a prezzo massimo acquisto senza sconto.
    </label>
    </div>
    <input-file class="mt-2 mb-2" @update="getDataFromFile" v-bind:type="'disabled'"></input-file> 
   <button :disabled="bt_spinner1" type="submit"  class="btn btn-primary float-right mt-2">
    <i class="far fa-play-circle mr-2"></i>
    ESEGUI RICERCA
      <span v-if="bt_spinner1" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
     </button>  
     
   <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>                  
  </form>
 </div>

  </div>
   </div>
</div>
<div v-else class="col">
<div >
  <button @click="type='A'"  type="button"  class="btn btn-secondary mr-3 ">
    <i style="color:yellow" class="fas fa-reply mr-2"></i>
    RITORNA A PARAMETRI RICERCA
  </button>  
    <!--     
    
     <button :disabled="progress > 0 || items.length == 0" @click="printPDF()" type="button"   class="btn btn-success mr-3 ">
<i class="fas fa-file-export mr-2"></i>
      ESPORTA PDF
     
</button>  
-->
<button :disabled="bt_spinner1"  @click="getDataToExport()" type="button"   class="btn btn-warning mr-2 ">

<i class="fas fa-file-export "></i>
      ESPORTA CSV
      <span v-if="bt_spinner1" class="spinner-border spinner-border-sm ml-2" role="status" aria-hidden="true"></span>
</button>  

  <alert-box class="mt-2" @close="msg.title=''" v-bind:msg="msg"  ></alert-box>

  <div class="table-wrapper-scroll-y my-custom-scrollbar">
    <div v-if="progress>0" class="progress">
        <div class="progress-bar progress-bar-striped" role="progressbar"  :style="{'width':getProgress}">
          {{ progress }}%
        </div>
</div>

  <table class="table table-sm mb-0">
    <thead >
      <tr class="table-primary">
        
        <th scope="col">SEDE</th>
        <th scope="col">STAGIONE</th>
        <th scope="col">ANNO</th>
        <th scope="col">REPARTO</th>

        <th class="text-right" scope="col">TOTALE</th>        
        <th class="text-right" scope="col">VALORE</th>  
        <th class="text-right" scope="col">VALORE RETAIL</th>  
        
      </tr>
    </thead>
    <tbody>
      <tr @click="openDetail(index)"  :style="{ color: item.row_type == 1  ? 'blue' : 'black',fontSize: item.row_type == 1 ? '20px':'15px',fontWeight:item.row_type == 1 || item.selected==1 ? 'bold':'normal' }"   data-toggle="tooltip" title="" class="pointer" v-for="(item, index) in items" :key="index">
        
        <td>{{item.store}} 
          <div class="" v-if="isOpen[index]==true">
          <component :key = "componentKey" v-bind:spinner="spinner1" v-bind:is="component" v-bind:items="products" ></component>          
          <span v-if="spinner1" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> 
          </div>
        </td>
        <td>{{item.season}} </td>
        <td>{{item.season_year}} </td>
        <td>{{item.department}} </td>
        <td class="text-right">{{fmt2(item.total_qty)}}</td>
        <td class="text-right">{{fmt1(item.total_value)}}</td>
        <td class="text-right">{{fmt1(item.total_retail_value)}}</td>
        
       
      </tr> 
    </tbody>
    <tfoot>
        <tr v-for="(item, index) in row_total" :key="index">
            
        <th></th>
        <th></th>
        <th></th>
        <th>TOTALI </th>
        <th class="text-right">{{fmt2(item.total_qty)}}</th>
        <th class="text-right">{{fmt1(item.total_value)}}</th>
        <th class="text-right">{{fmt1(item.total_retail_value)}}</th>
                
        </tr>   
    </tfoot>    
  </table>

</div>

 

</div>  
</div>
</div>
 
</div>

</div>
  
</div>

</template>
<script>

import api               from "@/api"
import { mapGetters }    from 'vuex';
import alertBox          from '@/components/common/AlertBox.vue';

import storeSelect       from '@/components/common/StoreSelect_1.vue'
import productList       from '@/components/common/ProductList.vue'
import seasonSelect      from '@/components/common/SeasonSelect_1.vue'
import yearSelect        from '@/components/common/YearSelect_1.vue'
import departmentSelect  from '@/components/common/DepartmentSelect_1.vue'
import fmt               from '@/components/mixins/fmt'
import inputFile         from '@/components/common/InputFile.vue';

import jsPDF             from 'jspdf';



export default {
  mixins     : [fmt],
  components: {alertBox,storeSelect,productList,seasonSelect,yearSelect,departmentSelect,inputFile},
  data() {
    return {

      type            : 'A',
      option          : 1,
      pdf_title       : 
      {
              
      },
      store             : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : false,
        required      : true
      },
      season          : 
      {
        Id            : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : false,
        type          : true


      },
      season_year     : 
      {
        year          : 0,
        isActive      : true,
       
        optionBase    : true,
        required      : false

      },
      department      : 
      {
        Id            : 0,
        isActive      : true,
        type          : true,
        optionBase    : true,
        required      : false
      },
  
      
      isOpen          : [], 
      
      
      bt_spinner1     : false,
      bt_spinner2     : false,
  

      msg             : {
        title : ''
      },    
      items           : [],
      row_total       : [],
      products        : [],
      spinner1        : false,
      component       : '',
      componentKey    : 0,
      detail          : [],
      progress        : 0
     
      
      
    };
  },

  computed :{
    ...mapGetters(['company']),
   
  getProgress()
  {
    let p = this.progress
    return p + "%";
  }
    
  },
  directives: {
    focus: {
      // directive definition

      inserted : function(el) 
      {
        //el.focus();
      }

    }
  },
  mounted: function() {
 
  },
 
  created: function() {

   


  },

  methods: {
    
    getDataFromFile()
    {

    },
    setStoreId(storeId,e)
    {      
      this.store.Id        = storeId
      this.pdf_title.store = e.target.options[e.target.options.selectedIndex].text  
            
    },  
    setSeasonId(seasonId,e)
    {           
      this.season.Id        = seasonId
      this.pdf_title.season = e.target.options[e.target.options.selectedIndex].text
    },      
    setYear(year,e)
    {
      this.season_year.year = year
      this.pdf_title.year   = e.target.options[e.target.options.selectedIndex].text
    },
    setDepartmentId(Id,e)
    {
      this.department.Id = Id
      this.pdf_title.department = e.target.options[e.target.options.selectedIndex].text 

    }, 

   async  openDetail(index)
    {
            
      if(this.isOpen[index]==true)
      {
        return
      }

      this.items.forEach(item=>{
        item.selected = 0
      })

      if(this.items[index]['row_type'] != 0)
      {
        return
      }

      this.items[index]['selected']=1
      this.isOpen   = []
      this.products = []
      this.spinner = true
      this.isOpen[index]=true

      const sp = {'sp' : 'spStoreStockInventoryDetail'}
      const data  = {

        'companyId'    : this.company.Id,
        'storeId'      : this.items[index]['storeId'],
        'departmentId' : this.items[index]['departmentId'],
        'seasonId'     : this.items[index]['seasonId'],
        'season_year'  : this.items[index]['season_year'],

      }

      const json  = Object.assign(data, sp)
      
      await api.post(json).then(res => {
         
         
          if(res.status==200)
            {
             
              this.products  = res.data.recordsets[0]
              this.component = ''            
              this.component = 'productList'
              this.componentKey++

              if(res.data.recordsets[0].length == 0)
              {
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = 'DATI INESISTENTI.'
                this.msg.type  = 1
              }

            }
            else if (res.status==500)
            {
              

              this.msg.title = 'ATTENZIONE '
              this.msg.body  = res.data
              this.msg.type  = 1

              

            }
          
          else
          {

            

            this.msg.title = 'ATTENZIONE '
            this.msg.body  = res
            this.msg.type  = 1
            
            

          }
      }).catch(err=>{
        
            

            this.msg.title = 'ATTENZIONE '
            this.msg.body  = err.message
            this.msg.type  = 1
        
        

      })
      
      this.spinner = false
      



    },
    

    submit() 
    {
          
      this.msg.title = ''    
      this.getData()

    },  
        
    async getData() {
            
      this.progress  = 0
      this.isOpen    = []
      this.row_total = []
      this.items     = []
      this.detail    = []

      
      const sp = {'sp' : 'spStoreStockInventory'}
      
      const data  = {'companyId':this.company.Id, 'storeId' : this.store.Id,'seasonId':this.season.Id,'season_year':this.season_year.year,'typeId':this.option,'departmentId':this.department.Id}
      
      //console.log(data)   

      var json  = Object.assign(data, sp)
      this.bt_spinner1 = true

      await api.post(json).then(res => {
        
          if(res.status==200)
            {
              if(res.data.recordsets[0].length==0)
              {   
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = 'DATI INESISTENTI.'
                this.msg.type  = 1
                return
              }   
              
              this.type = 'B'  
              
              this.items = res.data.recordsets[0].filter(item=>item.row_type==0)
              this.row_total = res.data.recordsets[0].filter(item=>item.row_type==1)
             // this.detail = res.data.recordsets[1]

              
                      
              this.items.forEach(item=>{
                item.selected = 0
                })
            }
           else if(res.status==500)
           {
               
                
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res.data
                this.msg.type  = 1
                
                    
           } 
           else
            {
                 
               
                this.msg.title = 'ATTENZIONE '
                this.msg.body  = res
                this.msg.type  = 1
                
                 
            } 
          

          }).catch(err => {
             
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = err.message
              this.msg.type  = 1
          }).finally(() => {
          this.bt_spinner1 = false
        });



      

    },
    async getDataToExport() {
            
                    
            this.detail    = []
            let sp = {'sp' : 'spStoreStockInventoryToCSV'}
            
         
            
            const data  = {'companyId':this.company.Id, 'storeId' : this.store.Id,'seasonId':this.season.Id,'season_year':this.season_year.year,'typeId':this.option,'departmentId':this.department.Id}
            
            //console.log(data)   
      
            const json  = Object.assign(data, sp)
            this.bt_spinner1 = true
      
            await api.post(json).then(res => {
              
                if(res.status==200)
                  {
                    if(res.data.recordsets[0].length==0)
                    {   
                      
                      this.msg.title = 'ATTENZIONE '
                      this.msg.body  = 'DATI INESISTENTI.'
                      this.msg.type  = 1
                      return
                    }   
                    
                    
                    this.detail = res.data.recordsets[0]
                    this.export_data()                            
                    

                  }
                 else if(res.status==500)
                 {
                     
                      
                      this.msg.title = 'ATTENZIONE '
                      this.msg.body  = res.data
                      this.msg.type  = 1
                      
                          
                 } 
                 else
                  {
                       
                     
                      this.msg.title = 'ATTENZIONE '
                      this.msg.body  = res
                      this.msg.type  = 1
                      
                       
                  } 
                
      
                }).catch(err => {
                   
                    this.msg.title = 'ATTENZIONE '
                    this.msg.body  = err.message
                    this.msg.type  = 1
                }).finally(() => {
                this.bt_spinner1 = false
              });
      
      
      
            
      
          },
      

    async printPDF()
    {
      
      
      function wait(ms) 
      {
          return new Promise(resolve => {
          setTimeout(() => { resolve('') },ms);
          })
      }
      
      let r = 0
      let last_row = 190
      let grandTotal_qty = 0
      let grandTotal1 = 0
      let grandTotal2 = 0

      let items = this.detail

      
      
      const doc = new jsPDF('landscape')

      var page = 1
            
      var row_index    = 1
      
      var init_row     = 31
      var row          = init_row
      var row_header   = row -5
      var col          = 5
      var col1         = 20
      var col2         = 70
   
      var col3         = 180
      var col4         = 230
      var col5         = 280  
      
      let store        = this.pdf_title.store
      let season       = ''
      let season_year  = ''
      let department   = ''
      if(this.season.Id > 0)
      {
        season = this.pdf_title.season
      }
      if(this.season_year.year > 0)
      {
        season_year = this.pdf_title.year
      }
      if(this.department.Id > 0)
      {
        department = this.pdf_title.department
      }

      var header = function(season,season_year)
      {
        //let season = !this.pdf_title.season ? 'TUTTE' :this.pdf_title.season
        var d = new Date();
        var n = d.toLocaleString();
        doc.setDrawColor(51,0,0)       
        doc.setFillColor(232,232,232)        
        doc.roundedRect(5, 5, 285, 16,2,2,'FD')        
        doc.setDrawColor(0)
        doc.setFontSize(14)
        doc.setFont("helvetica","bold");
        doc.text('VALORIZZAZIONE STOCK ' +  n ,  150, 10, null, null, "center");
        doc.text(store ,  150, 15, null, null, "center");
        doc.text(season  +  ' ' + season_year + ' ' + department, 150,20, null, null, "center");
                     
        doc.setFontSize(10)
        doc.setTextColor(0, 0, 255);
        doc.text('BRAND', col1,row_header);
        doc.text('PRODOTTO', col2,row_header);
        doc.text("TOTALE Q.TA", col3, row_header,{align:'right'});
        doc.text("VALORE IMMESSO", col4 , row_header,{align:'right'});
        doc.text("VALORE RETAIL", col5 , row_header,{align:'right'});
        doc.setTextColor(0, 0, 0);        
        doc.setFont("helvetica","normal");

      }
      var footer = function(page,pages)
      {
     
        doc.setPage(page)
        doc.setFontSize(8)
        doc.text('pag. ' + page.toString() + ' / ' + pages.toString(),  260, 200, null, null, "center");
       
      }

      //let season = this.pdf_title.season ? 'TUTTE' :this.pdf_title.season
      
      header(season,season_year)
      let j
      // MAIN LOOP
      let total_row  = items.filter(item => item.brand == 'zzzSubTotal')
      let data       = items.filter(item => item.brand != 'zzzSubTotal')
      let brand_rows = items.filter(item => item.brand != 'zzzSubTotal' && item.category == 'SubTotal')
      for (j = 0; j < data.length; j++) {
      
      let item = items[j]
             
        r++  
        this.progress = Math.round(r / items.length * 100)
        await wait(0) 
        if(item.category == 'SubTotal' && item.brand != 'zzzSubTotal')
        {
          grandTotal_qty += item.total_qty
          grandTotal1 += item.total1
          grandTotal2 += item.total2
        }

        
        doc.setFontSize(8)
       
        if(row > last_row )
        {
          page++  
          doc.addPage();
          row = init_row
          if(page>1)
          {
            row = 5
          }                    
        }
        doc.setTextColor(0, 0, 0)

       
       
        if(item.category != 'SubTotal')
        {
            doc.text(row_index.toString(), col, row)    
        }
        

        doc.setFont("helvetica","bold")
        doc.setFontSize(10)     
        doc.setTextColor(0, 0, 0);
        
        doc.setFont("helvetica","bold")
        


        if(item.category == 'SubTotal')
        {
            doc.roundedRect(5, row-5, 285, 6  ,2,2)                
            doc.setTextColor(14, 161, 0);            
            doc.setFontSize(14)     
        }
        
        if(item.brand == 'zzzSubTotal')
        {
          item.brand = 'TOTALE STOCK'
        }
            
        doc.text(item.brand.toString().substr(0,20), col1, row)
              
        let product = item.category.substr(0,item.category.indexOf("|"))
        doc.text(product.toString(), col2, row) 

        doc.text(this.fmt2(item.total_qty), col3, row,{align:'right'})
        doc.text(this.fmt1(item.total1), col4, row,{align:'right'})
        doc.text(this.fmt1(item.total2), col5, row,{align:'right'})
       
       doc.setTextColor(0, 0, 0);
       doc.setFont("helvetica","normal")

       row_index++ 
       row = row + 5

       if(row > last_row )
        {
          page++  
          
          doc.addPage();
          row = init_row
          if(page>1)
          {
            row = 5
          }
        }

       let n = col + 18
       let w = 11.8 
       let cols = []

       

        let first_index = item.category.indexOf('|')
        let last_index = item.category.lastIndexOf('|') 
        
        if(first_index > 0 && last_index > 0)
        {
        let header = item.category.substr(first_index+1,(last_index-first_index)-1)
        cols =  JSON.parse(header)
        doc.setFontSize(8)  
        // HEADER COLS
        cols.forEach(col => {  
        doc.setFillColor(240,240,240)  
        doc.rect(n -1, row -3, w, 4,'FD');
        doc.text(col.size.toString().substr(0,6) , n, row);  
        n= n + w
        })
        
        }

        first_index = item.category.lastIndexOf('|')
        if(first_index >0)
        {
        let data = item.category.substr(first_index+1)      
        let colors = JSON.parse(data)       
        row = row + 5
        colors.forEach(color => {
        doc.setFontSize(8)  
        if(row > last_row )
        {
          page++  
          
          doc.addPage();
          row = init_row
          if(page>1)
          {
            row = 5
          }                    
        }

        // COLOR
        doc.text(color.color.toString().substr(0,9) , 5, row )
        
        let sizes  = color.s
        n = col + 18

        // SIZES
        cols.forEach(col =>{
          sizes.forEach(size=>{
            doc.setDrawColor(200,200,200)       
            doc.rect(n -1, row -3, w, 4)
            doc.setDrawColor(0)       
            if(col.size == size.size) 
            { 
              doc.text(size.qty.toString().substr(0,10) , n, row )
            } 

          })
          n = n + w 
        })
                  
        row = row + 4
        
       })
    
       
       
       row = row + 4
    }      
    // END LOOP
    } 
    
      
      doc.setFontSize(10)
    
      doc.addPage();
      doc.setTextColor(0, 0, 255);
      doc.setFontSize(14)     
      doc.setFont("helvetica","bold")
      doc.text('TOTALE STOCK', col1, 10)
      doc.text(this.fmt2(total_row[0].total_qty), col3, 10,{align:'right'})
      doc.text(this.fmt1(total_row[0].total1), col4, 10,{align:'right'})
      doc.text(this.fmt1(total_row[0].total2), col5, 10,{align:'right'})
      doc.setTextColor(0, 0, 0);
      page++
      row = 20
      row_index = 1
      brand_rows.forEach(item => {

        doc.text(item.brand, col1, row)
        doc.text(this.fmt2(item.total_qty), col3, row,{align:'right'})
        doc.text(this.fmt1(item.total1), col4, row,{align:'right'})
        doc.text(this.fmt1(item.total2), col5, row,{align:'right'})
        row_index ++
        if(row_index < 36)
        {
          row = row + 5  
        }
        else
        {
          page++
          doc.addPage();
          row_index = 1
          row = 20

        }
        
      })

      for (let i = 1; i <= page   ; i++) {
          footer(i,page)
      }
      
      this.progress = 0
      let fileName = 'CheckList_' + Date.now().toString()
      window.open(doc.output('bloburl', { filename: fileName }), '_blank');
      
    },


    async export_data()
    {
            const data = this.detail
            const header =  Object.keys(data[0])
            const text_delimiter = '"'
            const newLine  = "\x0A"
            let sep = ','
            let row = '' 
            let csvContent = "data:text/csv;charset=utf-8,"             
            data.forEach(item => {
              
              row +=  Object.values(item).join(sep)  + newLine 
            })
            
            /*
            this.detail.forEach( (item) =>   {
                  
            
                      row = '"' + item.supplier + '"' + sep
                      + '"' + item.brand + '"' + sep
                      + '"' + item.sku + '"' + sep
                      + '"' + item.category + '"' + sep
                      + '"' + item.season + '"' + sep
                      + '"' + item.season_year + '"' + sep                      
                      + '"' + item.qty + '"' + sep
                      + '"' + this.fmt1(item.total) + '"' + sep
                      + '"' +  this.fmt1(item.retail_price) + '"' + sep
                      csv += row + "\r\n";
                  
            });
            */


              

            const encodedUri = encodeURI(csvContent+row);
            const link = document.createElement("a");
            link.setAttribute("href", encodedUri);
            link.setAttribute("download", "ValorizzazioneStock.csv");
            document.body.appendChild(link); // Required for FF

            link.click(); // This will download the data file named "my_data.csv".

         

          
          }



    


  }
};
</script>
<style scoped>


.my-custom-scrollbar {
position: relative;
height: 700px;
overflow: auto;
}
.pointer:hover
{
  _background-color: blue;
  color: white;
  cursor: pointer;
}


.table thead  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 16px;
    background   : hwb(45 4% 9%); 
    color        : black;   
    position     : sticky;
    top          : 0;
    z-index      : 10;

 }



.table tfoot  tr:nth-child(1) th
 {

    font-family  : 'Roboto Condensed';
    font-size    : 22px;
    font-weight  : bold;
    background   : white;
    color        : green;
    position     : sticky;
    bottom       : 0;
    z-index      : 10;
    height       : 50px;

 }

.table-wrapper-scroll-y {
display: block;
}
.table th:first-child
{
  border-radius : 0 0 0 10px;
}
.table th:last-child
{
  border-radius : 0 10px 0 0;  
}



h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 20px;
}
.form-check-label{
  cursor:pointer
}

</style>